import React from "react";
import { ListGroupItem, Badge, ControlLabel } from "react-bootstrap";
import "./LibraryBookItem.css";
import Rater from 'react-rater'

export default class LibraryBookItem extends React.Component {
	render() {
		const book = this.props.src;
		return (
			<ListGroupItem className="LibraryBookItem text-primary"
				key={book.ISBN}
				//eslint-disable-next-line="true"
				tag="div"
				onClick={this.props.onClick}
				header={book.Title || book.Info ? book.Info.volumeInfo ? book.Info.volumeInfo.title : 'Title Not Available' : 'Title Not Available' }>
				{book.Info ?
					<span className="bookDescription">						
						{book.Info.volumeInfo.authors ? book.Info.volumeInfo.authors.map((auth, a) => { return (<span key={a} >{auth} - </span>) }) : <span key={'noauth' + book.ISBN}>Author unknown</span>}
						<div>
						<img src={book.Info.volumeInfo && book.Info.volumeInfo.imageLinks ? book.Info.volumeInfo.imageLinks.smallThumbnail || "/img/nocover.png" : "/img/nocover.png"} alt={book.Title} className="img-rounded img-responsive pull-left" />
						<Rater rating={book.Review?book.Review.Score:0} interactive={false} />
						</div>
						{book.Info ? book.Info.volumeInfo ? <span>{book.Info.volumeInfo.subtitle}: -</span> : '' : ''}
						<span className="description">{(book.Info ? book.Info.volumeInfo.description ? book.Info.volumeInfo.description.length >500 ? book.Info.volumeInfo.description.substr(0, book.Info.volumeInfo.description.indexOf(' ', 500)).concat("  [...]") : book.Info.volumeInfo.description : 'No Description Available' : 'No Description Available')}</span>
						
						<span className="bookfooter" >
						
							{book.OpenRequests ? <ControlLabel bsStyle="primary" onClick={() => { return this.showBookRequests(book.OpenRequests) }}><Badge pill>{Object.keys(book.OpenRequests).length}</Badge> Request{Object.keys(book.OpenRequests).length > 1 ? "s" : ""}</ControlLabel> : ""}
							
							
						</span>
					</span>
					
					: "Book Information Not Available"}

			</ListGroupItem>

		)
	}
}



// WEBPACK FOOTER //
// ./src/components/LibraryBookItem.js